<template>
  <transition name="fade">
    <div
      v-if="showTrainingProgressModal"
      class="bg-black fixed h-screen bg-opacity-70 inset-0 z-50 w-full"
    >
      <div
        class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full overflow-y-auto"
      >
        <div class="flex justify-between items-center border-b-1.5 p-3">
          <p class="text-lg font-semibold">Training Progress</p>
          <img
            class="h-6 cursor-pointer hover:shadow-lg bg-primary rounded-md m-3"
            src="@/assets/icons/cross-white.png"
            alt="closeModal"
            @click="closeModal()"
          />
        </div>
        <div class="p-6">
          <div class="modal-body my-6">
            <el-steps :active="currentIndex" finish-status="success">
              <el-step title="Not Started"></el-step>
              <el-step title="In Progress"></el-step>
              <el-step title="Completed"></el-step>
            </el-steps>
          </div>
          <div class="modal-footer flex justify-end">
            <el-button @click="prevStatus" :disabled="currentIndex === 0">
              <i class="el-icon-arrow-left"></i> Back
            </el-button>
            <el-button
              type="warning"
              @click="nextStatus"
              :disabled="currentIndex === statuses.length"
            >
              Continue <i class="el-icon-arrow-right"></i>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "TrainingProgress",
  props: ["showTrainingProgressModal", "close", "training", "current", "currentProgress"],

  data() {
    return {
      statuses: ["NotStarted", "InProgress", "Completed"],
      currentIndex: 0,
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken", "getCurrentEmployeeId"]),
  },
  watch: {
    showTrainingProgressModal: {
      handler(newVal) {
        if (newVal) {
          this.currentIndex = this.statuses.indexOf(this.currentProgress) + 1;
        }
      },
      immediate: true,
    },
  },
  methods: {
    closeModal() {
      this.close();
    },
    prevStatus() {
      this.currentIndex = Math.max(1, this.currentIndex - 1);
      this.updateTrainingProgress(
        this.training,
        this.statuses[this.currentIndex]
      );
    },
    nextStatus() {
      if (this.currentIndex <= this.statuses.length) {
        this.currentIndex++;
        this.$emit("nextStep", this.currentIndex);
        this.updateTrainingProgress(
          this.training,
          this.statuses[this.currentIndex]
        );
      }
    },

    // /{organization}/training/progress/v1/update
    updateTrainingProgress(TrainingId , progress) {
      const data = {
        TrainingId,
        Progress: progress,
      };

      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .put(
          `${this.getOrganization}/training/progress/${this.$ApiVersion}/update`,
          JSON.stringify(data),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$notify({
                title: "Success",
                message: response.data.StatusMessage,
                type: "success",
              });
            } else {
              this.currentIndex--;
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.currentIndex--;
            this.edit_error = error.message;
            setTimeout(() => {
              this.edit_error = null;
            }, 2500);
          }
        );
    },
  },
};
</script>

<style scoped></style>
